import * as React from 'react';

function SvgCalendarRangeFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M4 .5a.5.5 0 00-1 0V1H2a2 2 0 00-2 2v1h16V3a2 2 0 00-2-2h-1V.5a.5.5 0 00-1 0V1H4V.5zM16 7V5H0v5h5a1 1 0 110 2H0v2a2 2 0 002 2h12a2 2 0 002-2V9h-6a1 1 0 110-2h6z' />
		</svg>
	);
}

export default SvgCalendarRangeFill;
